import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from 'semantic-ui-react'
import _ from 'lodash'

import { Dropdown, Toggle, Modal } from 'components/Common'
import { getSystemLng } from 'stores/Account/Select'
import accountActions from 'stores/Account/Actions'
import { useTranslation } from 'react-i18next'

import { useUserPreferences } from '@enlyt/base/services/useUserPreferences'
import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import defaultStyles from './styles'
import cssStyles from './SettingsModal.module.scss'

const LANGUAGE_OPTIONS = [
  {
    key: 'en',
    value: 'en',
    text: 'English'
  },
  {
    key: 'es',
    value: 'es',
    text: 'Español'
  }
]

const SettingsModal = ({
  isSyncAvailable = false,
  isModalOpen,
  setIsModalOpen,
  style
}) => {
  const styles = mergeStyles(defaultStyles, style)
  const { preferences, changePreference, isLoading, error } =
    useUserPreferences(isSyncAvailable)

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [setIsModalOpen])
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const systemLng = useSelector(getSystemLng)
  return (
    <Modal
      onClose={handleCloseModal}
      open={isModalOpen}
      header='Settings'
      style={styles.modal}
    >
      <div style={styles.section}>
        <Dropdown
          placeholder={
            _.find(LANGUAGE_OPTIONS, item => item.value === systemLng).text
          }
          label='Language preference'
          options={LANGUAGE_OPTIONS}
          onChange={(_, data) => {
            dispatch(accountActions.setSystemLng(data.value))
            i18n.changeLanguage(data.value)
          }}
        />
      </div>
      <div style={styles.section}>
        <span style={styles.sectionHeader}>Communication preferences</span>
        <Toggle
          label='Email'
          value={preferences.email}
          onChange={() => changePreference('email')}
          disabled={isLoading}
          style={styles.toggle}
        />
        <Toggle
          label='Text/SMS'
          value={preferences.textSms}
          onChange={() => changePreference('textSms')}
          disabled={isLoading}
          style={styles.toggle}
        />
      </div>
      <div style={styles.lastSection}>
        <span style={styles.sectionHeader}>Subscribe to content updates</span>
        <Toggle
          label='Nutrition'
          value={preferences.nutrition}
          onChange={() => changePreference('nutrition')}
          disabled={isLoading}
          style={styles.toggle}
        />
        <Toggle
          label='Exercise'
          value={preferences.exercise}
          onChange={() => changePreference('exercise')}
          disabled={isLoading}
          style={styles.toggle}
        />
        <Toggle
          label='Stress management'
          value={preferences.stressManagement}
          onChange={() => changePreference('stressManagement')}
          disabled={isLoading}
          style={styles.toggle}
        />
        <Toggle
          label='Upcoming events'
          value={preferences.upcomingEvents}
          onChange={() => changePreference('upcomingEvents')}
          disabled={isLoading}
          style={styles.toggle}
        />
        {error && <span style={styles.errorText}>Something went wrong</span>}
        {isLoading && (
          <div style={styles.loadingContainer}>
            <Loader className={cssStyles.loader} active size={'small'} />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default SettingsModal
